import React, {useEffect, useState, useMemo} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { themeViaForms } from '../../styledComponents/settings/theme.js';
import StyledIcon from '../../styledComponents/styles/Icon.styled';
import _orderBy from 'lodash/orderBy';
import styled, { ThemeProvider } from 'styled-components';
import { getAvailableTags } from '../../actions/formsActions.js';
import SubmissionTagDropDown from '../../styledComponents/styles/SubmissionTagDropDown.styled.js';
import { AccentButtonMediumNunito, ButtonMediumNunito } from '../../styledComponents/styles/Buttons.styled.js';
import { AccentButtonSpinner } from '../../styledComponents/styles/spinner.styled.js';
import { assignTravelerTags, fetchProfileData } from '../../actions/profileActions.js';
import { toast } from 'react-toastify';
import toastMessageStyles from '../../sites/viaGlobal/components/toastMessage/toastMessage.scss';

const FlexContainer = styled.div``;

const Header = styled.h1`
  font-family: Nunito, sans-serif;
  font-style: normal;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  color: #373737;
  margin-top: 15px;
`;
const ChildContainer = styled.div`
  margin-top: 33px;
`;

const Content = styled.div`
  // margin: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
`;

const SubmissionTagContainer = styled.div`
  width:85%;
`;

const SubmissionDropdown = styled(SubmissionTagDropDown)`
  padding-bottom: 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  height: 42px;
  padding: 8px 36px;
  justify-content: right;
  align-items: center;
  gap: 6px;
  margin-top: 20px;
`;

const TravelerTagsModal = (props) => {
  const dispatch = useDispatch();
  const availableTags = useSelector(state => state.forms.availableTags);
  const [travelerTag, setTravelerTag] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagSearchQuery, setTagSearchQuery] = useState('');
  const [isTagCreateForm, setIsTagCreateForm] = useState('create');
  const [showTagModal, setShowTagModal] = useState(false);
  const [previousSelection, setPreviousSelection] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const tagList = availableTags?.data?.data;
    
  const existingTags = tagList?.map(tag => {
      let tagLabel = tag.attributes.name;
      if (tag.attributes.emoji !== null && tag.attributes.emoji !== undefined) {
          tagLabel =
          tag.attributes.emoji
              .split(',')
              .join('')
              .trim() +
          ' ' +
          tag.attributes.name;
      }
      return {
          label: tagLabel,
          value: tag.id,
          name: tag.attributes.name.toLowerCase(),
          description: tag.attributes.description,
          bgcolor: tag.attributes.tag_color.bg_hex_code,
          textColor: tag.attributes.tag_color.font_hex_code,
      };
  });
  const existingSortedTags = _orderBy(existingTags, 'name', 'asc');

  function setTravelerTagValue() {
      const tagList = props.selectedTravelerTags?.map(tag => {
      let tagLabel = tag.name;
          if (tag.emoji !== null && tag.emoji !== undefined) {
              tagLabel = tag.emoji + ' ' + tag.name;
          }
          return {
              label: tagLabel,
              value: tag?.id?.toString(),
              bgcolor: tag.tag_color.bg_hex_code,
              textColor: tag.tag_color.font_hex_code,
          };
      });

      if (tagList?.length > 0) {
          setSelectedTags([...tagList]);
          setTravelerTag([...tagList]);
      } else if (tagList?.length == 0) {
          setSelectedTags([]);
          setTravelerTag([]);
      }
  }

  useEffect(() => {
    // traveler tag
    setTravelerTagValue();
  }, [props.selectedTravelerTags]);

  const finalSubmissionTags = useMemo(() => {
      let existingSubmissionTags = props?.selectedTravelerTags?.length > 0 && props.selectedTravelerTags?.map(tag => {
        return {
          tag_id: tag?.id,
          taggable_id: props.travelerId,
          status: 'no_change',
        };
      });
  
      let finalTags = existingSubmissionTags || [];

      if (!travelerTag || travelerTag?.length === 0) {
        finalTags = finalTags?.map(tag => {
          return {
            ...tag,
            status: 'remove',
          };
        });
        return finalTags;
      } else {
        let newTags = [];
  
        for (let i = 0; i < travelerTag?.length; i++) {
          let appTag = travelerTag[i];
          let existingTag = existingSubmissionTags?.length > 0 && existingSubmissionTags?.find(j => Number(j?.tag_id) === Number(appTag?.value));
  
          //if the current application tag not found in the existing tags, then add tag in the list
          if (!existingTag) {
            newTags.push({
              tag_id: appTag.value,
              taggable_id: props.travelerId,
              status: 'add',
            });
          }
        }
  
        finalTags = [...finalTags, ...newTags];
      }
  
      //check if traveler tags are found in the traveler tag, if not found then change the status to remove
      for (let i = 0; i < existingSubmissionTags?.length; i++) {
        let existingTag = existingSubmissionTags[i];
        let findExistingTag = travelerTag?.find(i => Number(i.value) === Number(existingTag.tag_id));
  
        if (!findExistingTag) {
          finalTags = finalTags.map(tag => {
            if (Number(tag.tag_id) === Number(existingTag?.tag_id)) {
              return {
                ...tag,
                status: 'remove',
              };
            }
            return tag;
          });
        }
      }
  
      return finalTags;
  }, [travelerTag, props.selectedTravelerTags]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      width: 'max-content',
      marginTop: '7px',
      marginLeft: '7px',
      padding: '4px 8px',
      gap: '4px',
      fontFamily: 'Open Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      borderRadius: '4px',
      display: 'flex',
      backgroundColor: 'none',
      color: state.data.textColor,
      backgroundColor: state.data.bgcolor,
      // padding: "0px",
      // backgroundColor: "white"
    }),
    multiValue: (styles, state) => ({
      ...styles,
      backgroundColor: state.data.bgcolor,
    }),
    multiValueLabel: (styles, state) => ({
      ...styles,
      color: state.data.textColor,
      fontWeight: '700',
      fontSize: '14px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
    }),
    placeholder: styles => {
      return {
        ...styles,
        color: '#555',
        fontFamily: 'Open Sans',
        fontSize: '14px',
        fontStyle: 'italic',
        fontWeight: '400',
        lineHeight: '120%',
        letterSpacing: '0.21px',
      };
    },
  };

  const handleShowTagModal = (value, formType, selectedTag) => {
    setIsTagCreateForm(formType);
    setShowTagModal(value);
    let tagList = travelerTag?.length > 0 ? travelerTag : selectedTag;
    if (tagOptions.length > 0) {
      const updatedTagsList = tagList?.filter(item1 => {
        return tagOptions.some(item2 => item2.value == item1.value);
      });
      setTravelerTag(updatedTagsList);
    } else {
      setTravelerTag(tagList);
    }
    
    // If opening the SubmissionTag modal, close the TravelerTagsModal and notify parent
    if (value && props.onOpenSubmissionTagModal) {
      props.onOpenSubmissionTagModal({
        tagSearchQuery: tagSearchQuery,
        isTagCreateForm: formType,
        applicationTag: tagList
      });
      props.onClose(false);
    }
  };

  const handleTagInputChange = inputValue => {
    setTagSearchQuery(inputValue);
  };
    
  const handleFilterOption = (option, rawInput) => {
    // Implement your custom filtering logic here.
    return option.label.toLowerCase().includes(rawInput.toLowerCase());
  };

  const tagOptions = existingSortedTags?.filter(tag => {
    return handleFilterOption(tag, tagSearchQuery);
  });
    
  const handleSelectChange = newValue => {
    const newSelection = newValue?.filter(option => !previousSelection?.includes(option));
    setTravelerTag(newValue);
    setPreviousSelection(newValue);
  };


  useEffect(() => {
    dispatch(getAvailableTags('User'));
  }, []);

  const handleSubmit = () => {
    const payload = {
        "user_tags": {
          "taggables_attributes": finalSubmissionTags
        }
      }
    setDisableSubmit(true);
    dispatch(assignTravelerTags(payload, (status, message) => {
      setDisableSubmit(false);
      if (status) {
        toast(message, {
          type: 'success',
          className: toastMessageStyles['successContainer'],
          toastClassName: toastMessageStyles['wrapper'],
          bodyClassName: toastMessageStyles['successBody'],
          progressClassName: toastMessageStyles['progress-bar'],
          position: 'bottom-right',
        });
        props.onClose(false)
        dispatch(fetchProfileData(props.travelerId, 'client'));
      } else {
        toast(message, {
          type: 'error',
          className: toastMessageStyles['failureContainer'],
          toastClassName: toastMessageStyles['wrapper'],
          bodyClassName: toastMessageStyles['failureBody'],
          progressClassName: toastMessageStyles['progress-bar'],
          position: 'bottom-right',
        });
      }
    }));
  }


  return (
    <ThemeProvider theme={themeViaForms}>
      <FlexContainer>
        <Modal
          blockScroll={false}
          open={props.show}
          onClose={() => props.onClose(false)}
          center
          styles={{
            overlay: { background: 'rgba(0, 0, 0, 0.65)' },
            modal: {
              maxWidth: '1000px',
              width: !!props.width ? props.width : '500px',
              height: '100%',
              padding: '0px',
              position: 'fixed',
              right: '0px',
              top: '0px',
              // overflow: 'scroll'
            },
            closeButton: {
              marginTop: '5.8px',
              marginRight: '20.8px',
              width: '24px',
              height: '24px',
            },
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}
          closeIcon={<StyledIcon type="Close" color="#9FABAE" size="24px" />}
        >
          <div style={{ overflow: 'scroll', height: '100%' }}>
            <Header>
              <a
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                onClick={() => props.onClose(false)}
              >
                <StyledIcon type="Close" color="#373737" size="24px" />
              </a>
              <span style={{ marginLeft: '10px' }}>Traveler Tags</span>
            </Header>
            <hr style={{ width: '100%', height: '2px', background: '#D7D7D7' }} />
            <ChildContainer>
              <Content>
                <SubmissionTagContainer>
                    <label style={{ marginTop: '10px', marginBottom: '0px' }}>{`Traveler Tags`}</label>
                    <SubmissionDropdown
                        key={`action_traveler_tag_${props.travelerId}`}
                        aria-label="Submission Tag"
                        applicationTag={travelerTag}
                        placeholder={'Type to select tag'}
                        id="traveler_tag"
                        options={tagOptions}
                        // submissionId={props.travelerId}
                        handleShowTagModal={handleShowTagModal}
                        handleInputChange={handleTagInputChange}
                        handleSelectChange={handleSelectChange}
                        tagSearchQuery={tagSearchQuery}
                        customStyles={customStyles}
                        width="100%"
                        // isDisabled={showNoteReviewTag == true ? true : false}
                    />
                </SubmissionTagContainer>               
              </Content>
              <ButtonWrapper>
                  <ButtonMediumNunito
                    type={'button'}
                    onClick={() => props.onClose(false)}
                  >
                  Cancel
                </ButtonMediumNunito>
                <AccentButtonMediumNunito type="button" disabled={disableSubmit} onClick={handleSubmit} >
                  {disableSubmit ? <AccentButtonSpinner displayText='Loading ...' /> : 'Assign Tag'}
                </AccentButtonMediumNunito>
              </ButtonWrapper>
            </ChildContainer>
          </div>
        </Modal>
      </FlexContainer>
    </ThemeProvider>
  )
}
export default TravelerTagsModal